export const lockTypeConfig = {
  heading: "الأقفال والدخول",
  subtitle:
    "كيف يدخل الضيف إلى مكان إقامتك؟ أضف قفلًا واحدًا أو أكثر (مدخل المبنى، الوحدة…)، لكلٍّ منها اسمه ونوع الدخول الخاص به.",
  loading: "جارٍ تحميل الإعداد…",

  enable: {
    title: "إرسال رموز الدخول",
    sub:
      "إذا أوقفت هذا الخيار فلن نرسل مفاتيح الدخول إلى الضيف. وستظل تعليمات الوصول تُرسَل بصرف النظر عن هذا الإعداد.",
  },

  scope: {
    labelRoom: "الغرفة المراد إعدادها",
    labelUnit: "الوحدة المراد إعدادها",
    hintRoom: "تحتفظ كل غرفة بإعداد الدخول الخاص بها.",
    hintUnit: "تحتفظ كل وحدة بإعداد الدخول الخاص بها.",
  },

  conflict: {
    title: "لن تستخدم هذه المساحات هذا الإعداد",
    textBefore:
      "تحتفظ بمفاتيحها الخاصة، وعند إرسالها يسود دائمًا الإعداد الأكثر تحديدًا.",
    textStrong: "ما تُحرّره هنا لن يصل إليها",
    textAfter: "طالما بقيت على هذا الحال:",
    lockCount: "قفل | أقفال",
    applying: "جارٍ التطبيق…",
    applyAll: "تطبيق هذا الإعداد على الجميع",
  },

  lockBadge: "القفل {n}",
  removeLock: "إزالة القفل",
  nameLabel: "اسم المدخل",
  namePlaceholder: "أو اكتب اسمًا…",
  typeLabel: "نوع الدخول",
  codePlaceholderBox: "رمز صندوق المفاتيح · مثال 5817",
  codePlaceholderLock: "رمز القفل · مثال 5817",
  lockFallback: "قفل",
  connectedSuffix: "متصل",
  editConfig: "تعديل الإعداد",
  configure: "إعداد…",
  addLock: "إضافة قفل آخر",
  roomsHint:
    "لكل غرفة فعلية قفلها ورمزها الخاص. قم بإعدادها هنا، واحدة تلو الأخرى.",

  wa: {
    online: "متصل الآن",
    today: "اليوم",
    captionOverriding: "هكذا يستقبله {source} · وليس المساحات المذكورة أعلاه",
    captionPreview: "معاينة · هكذا سيستقبله ضيف {source}",
  },

  modal: {
    title: "إعداد قفلك الذكي",
    sub: "اختر علامتك التجارية واربطها لإنشاء مفاتيح تلقائية لكل حجز.",
    close: "إغلاق",
    note: "أضف أولًا وحدة إلى الإعلان لإعداد القفل الذكي.",
  },

  providerOther: "علامة تجارية أخرى",

  presets: {
    main: "المدخل الرئيسي",
    property: "مدخل مكان الإقامة",
    unit: "مدخل الوحدة",
  },

  entryFallback: "المدخل",
  roomFallback: "غرفة",
  yourProperty: "مكان إقامتك",

  types: {
    none: {
      title: "صندوق مفاتيح",
      desc: "صندوق آمن يحتوي على مفاتيح مكان الإقامة.",
    },
    dynamic: {
      title: "قفل ذكي",
      desc: "مفتاح تلقائي جديد لكل حجز.",
    },
    static: {
      title: "قفل برمز ثابت",
      desc: "رمز يُغيَّر يدويًا بشكل دوري.",
    },
  },

  source: {
    room: "هذه الغرفة",
    unit: "مكان الإقامة هذا",
    property: "الإعلان",
  },

  preview: {
    boxText:
      "🔑 *{label} · {name}*\n\nيُفتح صندوق المفاتيح بالرمز: *{code}*\n\nستجد بالداخل مفاتيح مكان الإقامة. يُرجى إعادتها إلى مكانها عند مغادرتك.",
    dynamicText:
      "🔒🔑 *{label} · {name}*\n\nرمز دخولك هو: *58117*\n\nصالح طوال فترة إقامتك.",
    staticText:
      "🔒🔑 *{label} · {name}*\n\nرمز القفل هو: *{code}*\n\nاستخدمه لفتح باب مكان الإقامة.",
  },

  summary: {
    dynamic: "قفل ذكي",
    codePrefix: "الرمز {code}",
    staticCode: "رمز ثابت",
    boxPrefix: "صندوق المفاتيح {code}",
    empty: "غير مُعد",
  },

  toast: {
    saved: "تم حفظ الدخول",
    saveError: "تعذّر حفظ طريقة الدخول.",
    unified: "تم توحيد الإعداد",
    unifyError: "تعذّر توحيد الإعداد.",
    savedRoom: "تم حفظ الدخول · {room}",
    saveErrorRoom: "تعذّر حفظ دخول {room}.",
    theRoom: "الغرفة",
  },
};
